// pages/TravelAndTourism/index.jsx
/* eslint-disable @next/next/no-img-element */
import Image from "next/image";
import Header3 from "../../components/header/header-rslhome";
import Seo from "../../components/common/Seo";
import CtaButton from "../../components/buttonWithArrow";
import OverviewSection from "../../components/Investments/OverviewSection";
import ParticipationCosts from "../../components/Investments/ParticipationCosts";
import { TRAVEL_TOURISM, TRAVEL_TOURISM_PAGE } from "../../data/travelAndTourism";
import CommunicationChannel from "../../components/Investments/CommunicationChannel";
import Footer3 from "../../components/footer/footer-new";
import RoiInvestorBenefitsNew from "../../components/Investments/RoiInvestorBenefitsNew";
import InvestInFleets from "../../components/Investments/InvestInFleets";
import InvestorBenefitsBanner from "../../components/Investments/InvestorBenefitsBanner";
import OperationModelsNew from "../../components/Investments/OperationModelsNew";
import TravelForm from "../../components/all-services/travelForm";
import TravelCostCalculatore from "../../components/all-services/travelCostCalculatore";
import { Box, CircularProgress } from "@mui/material";
import React, { useEffect, useState } from "react";
import InvestNow from "../../components/investNow";
import { tourInvestNow, getTourDatas } from "../../redux/slices/investments";
import { useDispatch, useSelector } from '../../redux/store'
import { bannerHeight } from "../../utils/bannerHeight";
import { fetchSeoByPage } from "../../lib/seoHelper";

// "RSL-Purchased Vehicle" option hidden - remove this filter to bring it back
const HIDDEN_OPTION_VALUE = "RSL";
const isHiddenOption = (name = "") => /rsl[-\s]*purchased/i.test(name);

export default function TravelAndTourism({ meta }) {
  const HEADER_OFFSET = 88;
  const dispatch = useDispatch();
  const scrollToId = (id) => {
    const el = document.getElementById(id);
    if (!el) return;
    const y = el.getBoundingClientRect().top + window.pageYOffset - HEADER_OFFSET;
    window.scrollTo({ top: y, behavior: "smooth" });
  };
  const { tourEnquiryRes, allTourRes } = useSelector(
    state => state.investment
  );
  const [tab, setTab] = React.useState(null);
  const [loader, setLoader] = React.useState(true);
  const [travelTypeData, setTravleTypeData] = React.useState([]);
  const [datas, setDatas] = React.useState({
    brand: [],
    year: [],
    condition: [],
    driver: []
  });
  const [openEnquire, setOpenEnquire] = React.useState(false);
  const [openCostCal, setOpenCostCal] = React.useState(false);
  const [vehicle, setVehicle] = React.useState(null);
  const [openInvestForm, setOpenInvestForm] = React.useState(false);
  const [investFormLoader, setInvestFormLoader] = React.useState(false);
  const [bannerImage, setBannerImage] = useState(null);
  const costCalculatorOptions = React.useMemo(
    () => (TRAVEL_TOURISM_PAGE?.tabData || []).filter((item) => item?.value !== HIDDEN_OPTION_VALUE),
    []
  );

  React.useEffect(() => {
    if (costCalculatorOptions?.length > 0) {
      setTab(costCalculatorOptions[0]);
      setVehicle(costCalculatorOptions[0].value)
      setLoader(false);
    }
    dispatch(getTourDatas());
  }, [TRAVEL_TOURISM_PAGE]);

  useEffect(() => {
    if (allTourRes) {
      if (allTourRes?.status === 1) {
        setTravleTypeData((allTourRes?.data?.typeData || []).filter((item) => !isHiddenOption(item?.name)));
        setDatas({
          brand: allTourRes?.data?.brands,
          year: allTourRes?.data?.years,
          condition: allTourRes?.data?.conditions,
          driver: allTourRes?.data?.driverOptions,
        })
        setBannerImage(allTourRes?.data?.bannerImage);

      } else {
        setTravleTypeData([]);
        setDatas({
          brand: [],
          year: [],
          condition: [],
          driver: []
        });
        setBannerImage(null);
      }
    }
  }, [allTourRes])

  // const handleCloseEnquire = () => setOpenEnquire(false);
  // const handleOpenEnquire = () => setOpenEnquire(true);


  console.log("tab",tab);
  
  const handleCloseCostCalculatore = () => setOpenCostCal(false);
  const handleOpenCostCalculatore = () => setOpenCostCal(true);

  if (loader) {
    return (
      <CircularProgress
        style={{
          color: "green",
          width: "50px",
          height: "50px",
        }}
      />
    );
  }

  const handleCloseInvestForm = () => setOpenInvestForm(false);
  const handleOpenInvestForm = () => setOpenInvestForm(true);

  const handleInvestFormSubmit = (value) => {
    const obj = {
      ...value,
      currency: typeof window !== "undefined"
        ? JSON.parse(sessionStorage.getItem("currency") || "{}")?.value || "aed"
        : "aed"
    }
    setInvestFormLoader(true);
    dispatch(tourInvestNow(obj));
  }

  return (
    <>
      <Seo meta={meta} />
      <Header3 bgColor="#EBEBEB" borderColor="#DFDFDF" />

      <section
        className="hero"
        style={{
          position: "relative",
          width: "100%",
          height: bannerHeight(),
          overflow: "hidden",
        }}
      >
        {/* Fixed background layer */}
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: bannerHeight(),
            zIndex: 0,
          }}
        >
          {/* BG image */}
          <Image
            // src="/img/investments/travel/banner.svg"
            src={bannerImage ? `${process.env.IMAGE_BASE_URL}/${bannerImage}` : "/img/investments/travel/banner.svg"}
            alt="limousine"
            fill
            priority
            sizes="100vw"
            style={{ objectFit: "cover" }}
          />
          {/* Gradient overlay */}
          <div
            style={{
              position: "absolute",
              bottom: 0,
              left: 0,
              right: 0,
              top: 0,
              background: "linear-gradient(to top, rgb(0 0 0) 0%, rgba(0, 0, 0, 0) 35%)",
              zIndex: 1,
              pointerEvents: "none",
            }}
          />
          {/* dark gradient overlay */}
          {/* <div className="overlay" aria-hidden="true" /> */}

          {/* content */}
          <div className="content">
            <h1 className="title jura">
              <span className="scribble-wrap">
                <span className="scribble-text">Invest</span>
                {/* teal hand-drawn oval */}
                <img
                  src="/img/header/Oval.svg"
                  alt=""
                  className="scribble"
                />
              </span>{" "}
              Travel & Tourism
            </h1>

            <div className="cta">
              <CtaButton label="Cost Calculator" onClick={handleOpenCostCalculatore} />
            </div>
          </div>
        </div>
      </section>
      <Box
        id="fleet"
        sx={{
          position: "relative",
          zIndex: 3,
          pt: `${bannerHeight()}px`,
        }}
      >
        <Box id="fleet" sx={{ scrollMarginTop: { xs: '80px', md: '96px' } }}>
          <OverviewSection data={TRAVEL_TOURISM?.overviewSection} bgcolor="#ffffff" onClick={handleOpenInvestForm} />
        </Box>
        {/* Invest in our Fleets section hidden - uncomment to bring it back */}
        {/* <InvestInFleets data={TRAVEL_TOURISM_PAGE?.investInFleets} bgcolor="#ffffff" onClick={handleOpenInvestForm} /> */}
        <InvestorBenefitsBanner data={TRAVEL_TOURISM_PAGE?.investorBenefits} bgcolor="#ffffff" />
        <OperationModelsNew data={TRAVEL_TOURISM_PAGE?.operationModelsNew} onClick={handleOpenInvestForm} />

        {/* <RoiInvestorBenefitsNew data={tab?.data?.roiInvestorBenefitsNew} bgcolor="#f8f8f8" onClick={handleOpenInvestForm} />
        <ParticipationCosts data={tab?.data?.participationCosts} bgcolor="#ffffff" onClick={handleOpenInvestForm} /> */}
        <Box sx={{ background: "#fff" }}>
          <CommunicationChannel data={TRAVEL_TOURISM?.communicationChannel} />
        </Box>
        <Footer3 bgcolor="#f8f8f8" />
      </Box>
      <TravelCostCalculatore
        options={costCalculatorOptions}
        setJetOption={setVehicle}
        jetOption={vehicle}
        open={openCostCal}
        handleClose={handleCloseCostCalculatore}
        onSubmit={() => console.log("")}
        onOrderNow={() => console.log("")}
        datas={datas}
      />

      <InvestNow
        open={openInvestForm}
        onClose={handleCloseInvestForm}
        fleetCard={travelTypeData}
        handleSubmit={handleInvestFormSubmit}
        loader={investFormLoader}
        setLoader={setInvestFormLoader}
        labels={["Name", "Email", "Phone", "Select Type", "Document"]}
        apiResponse={tourEnquiryRes}
      />

      <style jsx>{`
        :global(html, body) {
         scroll-behavior: smooth;
          overflow-x: hidden;
        }

        .hero {
          position: relative;
          width: 100%;
          // min-height: clamp(60vh, 90vh, 90vh);
          min-height: ${bannerHeight()};
          border-radius: 0;
          isolation: isolate; /* ensure overlay/contents stack correctly */
        }

/* ✅ Mobile-specific override */
// @media (max-width: 600px) {
//   .hero {
//     min-height: 60vh; /* shorter for phones */
//   }
// }

/* ✅ Tablet override */
// @media (min-width: 601px) and (max-width: 900px) {
//   .hero {
//     min-height: 70vh;
//   }
// }
        .overlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(
              to top,
              rgba(0, 0, 0, 0.78) 0%,
              rgba(0, 0, 0, 0.55) 35%,
              rgba(0, 0, 0, 0.08) 70%,
              rgba(0, 0, 0, 0) 100%
            ),
            radial-gradient(60% 60% at 50% 50%, rgba(0, 0, 0, 0.25), transparent 70%);
          z-index: 1;
          pointer-events: none;
        }

        .content {
          position: absolute;
          inset: 0;
          z-index: 2;
          display: grid;
          place-items: end center;
          padding: clamp(16px, 4vw, 28px);
          /* push content slightly above bottom like the mock */
          align-content: end;
          gap: clamp(16px, 3vh, 28px);
          padding-bottom: clamp(36px, 10vh, 40px);
          text-align: center;
        }

        .title {
          color: #ffffff;
          font-weight: 600;
          letter-spacing: 0.02em;
          line-height: 1.1;
          margin: 0;
          /* responsive font like the design */
          font-size: clamp(28px, 6.5vw, 52px);
          text-shadow: 0 2px 10px rgba(0, 0, 0, 0.4);
        }

        .scribble-wrap {
          position: relative;
          display: inline-block;
        }

        .scribble-text {
          position: relative;
          z-index: 2;
        }

        .scribble {
          position: absolute;
          z-index: 1;
          left: -0.35em;
          top: 5px;
          width: clamp(7.5em, 14vw, 13em); /* scales with font size */
          height: auto;
          transform: rotate(-4deg);
          pointer-events: none;
          filter: drop-shadow(0 2px 2px rgba(0, 0, 0, 0.25));
          opacity: 0.95;
        }

        .cta {
          display: flex;
          justify-content: center;
        }

        /* Button polish to match mock (rounded pill + subtle shadow) */
        :global(.cta button),
        :global(.cta a) {
          border-radius: 999px !important;
          box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);
        }

        /* Responsive tweaks */
        @media (max-width: 768px) {
          .content {
            padding-bottom: 48px;
          }
          .scribble {
            left: -0.3em;
            top: 10px;
          }
        }

        @media (max-width: 420px) {
          .title {
            line-height: 1.08;
            letter-spacing: 0.01em;
          }
          .scribble {
            width: 8.8em;
          }
        }
      `}</style>
    </>
  );
}

export async function getServerSideProps(context) {
  const rawPath = context.resolvedUrl;
  let path = rawPath.split("?")[0];
  if (path.length > 1 && path.endsWith("/")) {
    path = path.slice(0, -1);
  }
  const metaHome = await fetchSeoByPage(path);
  return {
    props: { meta: metaHome }
  };
}